import i18next from 'i18next';
import ICU from 'i18next-icu';

export default function i18n({ locale, resource }) {
  i18next.use(ICU).init({
    keySeparator: '$',
    lng: locale,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    resources: {
      [locale]: {
        translation: resource,
      },
    },
  });
  return i18next;
}
